module.exports = __webpack_public_path__ + "img/logo.e0927cb8.svg";